<script>
  export let className = "";
  export let height = 1;
</script>

<style>
  svg {
    display: block;
  }
</style>

<svg
  class={className}
  height={`${height}em`}
  viewBox="0 0 20 20"
  focusable="false"
  role="img"
  aria-hidden="true">
  <path d="M0,0v4l8,8v8h4v-8l8-8V0H0z M10,8.8L4.4,3.2h11.3L10,8.8z" />
</svg>
